var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "slot-buttons" }, [
    _c(
      "div",
      {
        ref: "container",
        staticClass: "slot-buttons__container",
        style: {
          "grid-template-columns": `repeat(${_setup.numberOfCols}, 1fr)`,
        },
      },
      [
        _vm._l(_vm.currentDaySlots, function (slot, slotIndex) {
          return _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _setup.isExpanded ||
                    slotIndex < _setup.numberOfVisibleSlots - 1 ||
                    _vm.currentDaySlots.length <= _setup.numberOfVisibleSlots,
                  expression:
                    "isExpanded || slotIndex < numberOfVisibleSlots - 1 || currentDaySlots.length <= numberOfVisibleSlots",
                },
              ],
              key: slotIndex,
              staticClass: "slot-buttons__button b-button pa-1",
              class: _setup.getNamespace(slot).button,
              attrs: {
                "data-qa": "appointment-calendar-button-slot",
                "data-google-goal": "click_appointment_slot",
                type: "button",
                "data-doctor": _vm.doctorId,
              },
              on: {
                click: function ($event) {
                  return _setup.handleClickSlot($event, slot)
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "text-subtitle-1",
                  class: _setup.getNamespace(slot).text,
                },
                [_vm._v("\n        " + _vm._s(slot.time) + "\n      ")]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _setup.hasExpandButton
          ? _c(
              "button",
              {
                staticClass:
                  "slot-buttons__button b-button b-button_light primary--text pa-1",
                attrs: {
                  type: "button",
                  "data-qa": "appointment-calendar-button-expand",
                },
                on: {
                  click: function ($event) {
                    _setup.isExpanded = !_setup.isExpanded
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "ui-icon-fz-medium",
                  class: _setup.isExpanded
                    ? "ui-icon-arrow-up"
                    : "ui-icon-arrow-down",
                }),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }